// extracted by mini-css-extract-plugin
export default {"container":"MultipartPhone_container__s+Uj3","row":"MultipartPhone_row__GxAw9"};